import { useCallback } from 'react'
import { Link, useHistory } from 'react-router-dom-v5'
import Header from '../components/header'
import { useCampaign } from '../hooks/use-campaign'
import { Logo, Logout } from './icon'

const AdminHeader = () => {
  const { campaignCodeFromUrl } = useCampaign()
  const history = useHistory()
  const handleLogout = useCallback(() => {
    sessionStorage.removeItem('admin')
    history.push(`/admin/${campaignCodeFromUrl}/admin-login`)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const logo = (
    <Link to={`/admin/${campaignCodeFromUrl}/admin-login`}>
      <Logo />
    </Link>
  )

  const logout = (
    <button className="icon-button" onClick={handleLogout}>
      <Logout />
    </button>
  )

  return <Header left={logo} right={logout} classes="admin-header" />
}

export default AdminHeader
